import { Button, Drawer, Form, Input, InputNumber, Radio } from "antd";

import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
	loadOverlappingLeaves,
	loadSingelLeaveApplication,
	reviewLeaveApplication,
} from "../../../redux/rtk/features/leave/leaveSlice";
import { loadAllPublicHoliday } from "../../../redux/rtk/features/publicHoliday/publicHolidaySlice";
import getPermissions from "../../../utils/getPermissions";
import getUserFromToken from "../../../utils/getUserFromToken";
import PublicHolidayDatePicker from "../../leave/publicHoliday";

const ReviewLeavePopup = () => {
	const { id } = useParams("id");
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const [loader, setLoader] = useState(false);
	const data = useSelector((state) => state.leave.leave);
	const userId = getUserFromToken();
	const [status, setStatus] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [totalDays, setTotalDays] = useState(1);
	const publicHolidayData = useSelector((state) => state.publicHoliday.list || []);

	const publicHolidays = Array.isArray(publicHolidayData) ? publicHolidayData : [];
	console.log("publicHolidays", publicHolidays);
	const [initialValues, setInitialValues] = useState({});
	const permissions = getPermissions();

	const overlap = useSelector((state) => state.leave.overlappingLeaves)
	console.log("ov",overlap);
	
	// useEffect(() => {
	// 	dispatch(loadOverlappingLeaves({leaveFrom:"2025-01-20",leaveTo:"2025-01-21"}))
	// }, [])

	const hasPermission = (item) => {
		return permissions?.includes(item ? item : "");
	};
	useEffect(() => {
		const loadData = async () => {
			try {
				await Promise.all([
					dispatch(loadAllPublicHoliday()),
				]);
			} catch (error) {
				console.error('Error loading calendar data:', error);
			}
		};
		loadData();
	}, [dispatch, userId]);
	
	useEffect(() => {
		console.log("data?.acceptLeaveFrom", data?.leaveFrom);
		console.log("data?.leaveTo", data?.leaveTo);

		dispatch(loadOverlappingLeaves({leaveFrom:data?.leaveFrom,leaveTo:data?.leaveTo}))


		setInitialValues({
			...data,
			userId: userId,
			status: status,
			totalleaveDays: data?.totalleaveDays,
			acceptLeaveFrom: dayjs(data?.leaveFrom),
			acceptLeaveTo: dayjs(data?.leaveTo),
		});
	}, [data]);

	const policyStart = data?.leavePolicy?.validity?.validFrom || data?.leavePolicy?.validFrom;
	const policyEnd = data?.leavePolicy?.validity?.validTo || data?.leavePolicy?.validTo;

	const onFinish = async (values) => {
		console.log("values", values);

		const FormData = {
			...values,
			acceptLeaveFrom: values.acceptLeaveFrom
				? dayjs(values.acceptLeaveFrom).format("YYYY-MM-DD")
				: values.acceptLeaveFrom,
			acceptLeaveTo: values.acceptLeaveTo
				? dayjs(values.acceptLeaveTo).format("YYYY-MM-DD")
				: values.acceptLeaveTo,
		};
		const resp = await dispatch(
			reviewLeaveApplication({ id: id, values: FormData })
		);

		if (resp.payload.message === "success") {
			setOpen(false);
			dispatch(loadSingelLeaveApplication(id));
			setLoader(false);
			setStatus(null);
		} else {
			setLoader(false);
		}
	};
	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding department");
		setLoader(false);
	};
	const [open, setOpen] = useState(false);
	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
		setStatus(null);
	};

	const calculateLeaveDays = (startDate, endDate, weeklyOffs, publicHolidays) => {
		console.log("startDate", startDate);
		console.log("endDate", endDate);


		if (!startDate || !endDate) return 0;

		let totalDays = 0;
		let currentDate = dayjs(startDate);
		const publicHolidayDates = new Set(
			publicHolidays.map((holiday) => dayjs(holiday.date).format("YYYY-MM-DD"))
		);

		while (currentDate.isSameOrBefore(endDate, 'day')) {
			const isWeekend =
				currentDate.day() === 0 || currentDate.day() === 6; // 0 = Sunday, 6 = Saturday
			const isWeeklyOff = isWeekend || weeklyOffs.includes(currentDate.format('YYYY-MM-DD'));
			// const isPublicHoliday = publicHolidays.some(
			//   (holiday) => holiday.date === currentDate.format('YYYY-MM-DD')
			// );
			const currentDateString = currentDate.format("YYYY-MM-DD");
			const isPublicHoliday = publicHolidayDates.has(currentDateString);
			console.log("isPublicHoliday", isPublicHoliday);

			if (!isWeeklyOff && !isPublicHoliday) {
				totalDays++;
			}

			currentDate = currentDate.add(1, 'day');
		}

		return totalDays;
	};



	const handleStartDateChange = (date) => {
		const endDate = form.getFieldValue('acceptLeaveTo');
		console.log("end", endDate);
		console.log("date", date);


		const leaveDays = calculateLeaveDays(date, endDate, [], publicHolidays);
		console.log("l", leaveDays);

		setTotalDays(leaveDays);
		form.setFieldsValue({ totalleaveDays: leaveDays });
		setEndDate(endDate);
	};

	const handleEndDateChange = (date) => {
		const startDate = form.getFieldValue('acceptLeaveFrom');
		console.log("startDate", startDate);
		console.log("date", date);
		const leaveDays = calculateLeaveDays(startDate, date, [], publicHolidays);
		console.log("lE", leaveDays);

		setTotalDays(leaveDays);
		form.setFieldsValue({ totalleaveDays: leaveDays });
		setEndDate(date);
	};


	return (
		<>
			{hasPermission("update-role") && (
				<Button onClick={showDrawer} className="mt-4" type="primary">
					Review Leave
				</Button>
			)}

			{data && (
				<Drawer
					width={720}
					title='Leave Review'
					placement='right'
					onClose={onClose}
					open={open}>
					<h2 className='text-2xl font-semibold mb-4 text-center mt-5'>
						Approve Leave
					</h2>
					<Form
						className='list-inside list-none border-2 border-inherit rounded px-5 py-5 m-5 mt-10'
						form={form}
						style={{ marginBottom: "40px" }}
						name='basic'
						initialValues={initialValues}
						labelCol={{
							span: 7,
						}}
						wrapperCol={{
							span: 12,
						}}
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						autoComplete='off'>
						<div>
							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Accept From'
								name='acceptLeaveFrom'
								rules={[
									{
										required: true,
										message: "Please input Date !",
									},
								]}>
								<PublicHolidayDatePicker
									publicHolidays={publicHolidays}
									validFrom={policyStart}
									validTo={policyEnd}
									onChange={(date, holiday) => {
										handleStartDateChange(date);
										if (holiday) {
											console.log(`Selected date is a holiday: ${holiday.name}`);
										}
									}}
									format="YYYY-MM-DD"
									showTime={false}
									showToday={false}
								/>
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Accept To'
								name='acceptLeaveTo'
								rules={[
									{
										required: true,
										message: "Please input Date!",
									},
								]}>
								<PublicHolidayDatePicker
									publicHolidays={publicHolidays}
									validFrom={policyStart}
									validTo={policyEnd}
									value={endDate}
									onChange={handleEndDateChange}
									format="YYYY-MM-DD"
									showTime={false}
									showToday={false}
								/>
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Total Leave Days'
								name='totalleaveDays'>
								<InputNumber name='totalleaveDays' />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Comment'
								name='reviewComment'>
								<Input name='reviewComment' />
							</Form.Item>

							{status === null && (
								<p className='text-red-500 text-center mb-3'>
									Please select status
								</p>
							)}

							<Form.Item
								style={{ marginBottom: "10px" }}
								label='Select Status'
								name='status'
								rules={[
									{
										required: true,
										message: "Please input Status!",
									},
								]}>
								<Radio.Group
									buttonStyle='solid'
									onChange={(e) => setStatus(e.target.value)}>
									<Radio.Button value='ACCEPTED'>ACCEPTED</Radio.Button>
									<Radio.Button value='REJECTED'>REJECTED</Radio.Button>
								</Radio.Group>
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								wrapperCol={{
									offset: 7,
									span: 12,
								}}>
								<Button
									onClick={() => setLoader(true)}
									type='primary'
									size='middle'
									htmlType='submit'
									block
									disabled={status === null}
									loading={loader}>
									Save
								</Button>
							</Form.Item>
						</div>
					</Form>
				</Drawer>
			)}
		</>
	);
};
export default ReviewLeavePopup;
